const icon = require('vue-svgicon');
icon.register({
    'lens-feature-anti-reflection': {
        width: 40,
        height: 40,
        viewBox: '0 0 40 40',
        data: `<path pid="0" d="M7 20c6.5 0 13 4.5 13 9 0-4.5 6.5-9 13-9-6.5 0-13-4.5-13-9 0 4.5-6.5 9-13 9z" _stroke="#000" stroke-linejoin="bevel"/><path pid="1" d="M9 13c6.75 0 13.5 4.5 13.5 9 0-4.5 6.75-9 13.5-9-6.75 0-13.5-4.5-13.5-9 0 4.5-6.75 9-13.5 9z" _stroke="#000" stroke-linejoin="bevel"/><path pid="2" d="M4 27c6.75 0 13.5 4.5 13.5 9 0-4.5 6.75-9 13.5-9-6.75 0-13.5-4.5-13.5-9 0 4.5-6.75 9-13.5 9z" _stroke="#000" stroke-linejoin="bevel"/>`,
    },
});
